import { isTokenExpired } from '@dtvgo/utils';

const shouldUpdateToken = ({
  refreshToken,
  idToken,
  offsetMinutes
}) => ({
  isIdTokenExpired: isTokenExpired(idToken),
  isIdTokenExpiring: isTokenExpired(idToken, { secondsBefore: offsetMinutes * 60 }),
  isRefreshTokenExpired: isTokenExpired(refreshToken)
});

export { shouldUpdateToken };
//# sourceMappingURL=utils.js.map
